<script>
    import MessageBubble from './MessageBubble.svelte';
  
    export let messages = [];
    export let isLoading = false;
    export let chatContainer;
  </script>
  
  <div class="chat-messages border-dark border mt-2" bind:this={chatContainer}>
    <!-- Loop through messages -->
    {#each messages as msg}
      <MessageBubble role={msg.role} content={msg.content} attachments={msg.attachments}/>
    {/each}
  
    <!-- Loading Indicator -->
    {#if isLoading}
      <div class="d-flex justify-content-start mb-3">
        <div class="message-bubble text-dark bg-white border-dark shadow-sm p-3 border border-dark rounded-5">
          <div class="spinner-border spinner-border-sm text-dark me-2"></div>
          Generating codes...
        </div>
      </div>
    {/if}
  </div>
  
  <style>
    .chat-messages {
      height: calc(100vh - 300px); /* adjust for your layout */
      overflow-y: auto;
      background-color: #fafafa;
      padding: 1rem;
      border-top-left-radius: 24px;
      border-bottom-left-radius: 24px;
      text-align: left;
      scrollbar-width: thin;
      scrollbar-color: #888 #f0f0f0;
    }

    .chat-messages::-webkit-scrollbar {
      width: 8px;
    }
    .my-scrollable-div::-webkit-scrollbar-track {
        background: #f0f0f0; /* Track color */
        border-radius: 8px;  /* Round the edges */
    }

    .my-scrollable-div::-webkit-scrollbar-thumb {
        background-color: #888;        /* Thumb color */
        border-radius: 8px;            /* Round the thumb */
        border: 2px solid #f0f0f0;     /* Creates a little space around thumb */
    }

    .my-scrollable-div::-webkit-scrollbar-thumb:hover {
        background-color: #555; /* Darker on hover */
    }
  </style>
  